"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOrderReceivedOrganizationMockData = void 0;
const enums_1 = require("../../enums");
const mobile_app_links_1 = require("../../helpers/mobile-app-links");
const organization_facing_base_1 = require("./organization-facing-base");
const DEFAULT_PARTICIPANTS = [
    {
        ticketName: "General admission",
        ticketPrice: "$60.00",
        answers: [{ question: "Dietary restrictions", answer: "Vegetarian" }],
    },
    { ticketName: "VIP table", ticketPrice: "$120.00", answers: [] },
];
const DEFAULT_ADD_ONS = [
    { rateName: "Drink ticket", rateQuantity: 4, ratePrice: "$48.00" },
    { rateName: "Parking pass", rateQuantity: 1, ratePrice: "$10.00" },
];
const DEFAULT_PURCHASED_PRODUCTS = [
    {
        rateName: "Zeffy hoodie",
        rateQuantity: 2,
        ratePrice: "$55.00",
        variants: [
            { name: "Size", value: "Small" },
            { name: "Color", value: "Blue" },
        ],
        answers: [{ question: "Custom embroidery", answer: "Bright Futures" }],
    },
    { rateName: "Tote bag", rateQuantity: 1, ratePrice: "$25.00", variants: [], answers: [] },
];
const buildOrderReceivedOrganizationMockData = ({ locale = "en", subject = "New order on Sandbox Gala", isShop = false, isRaffle = false, formCategory = enums_1.TicketingFormCategory.Event, formTitle = "Sandbox Gala", eventStartDate = "Saturday, May 16, 2026 at 6:00 PM", eventEndDate = null, amount = "$180.00", buyerName = "Jane Donor", buyerEmail = "jane.donor@example.com", address = "500 Park Avenue, New York, NY", fundName = "Scholarship Fund", paymentMethod = "Credit card", isPadOrAch = false, isFreeOrder = false, currency = "usd", additionalBuyerQuestions = [{ question: "How did you hear about us?", answer: "From a friend" }], participants = DEFAULT_PARTICIPANTS, addOns = DEFAULT_ADD_ONS, purchasedProducts = DEFAULT_PURCHASED_PRODUCTS, extraDonation = "$20.00", showSavedAmount = true, formattedSavedAmount = "$5.67", transactionNumber = "42nd", viewPaymentLink = "https://www.zeffy.com/en-US/o/payments", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    isShop,
    isRaffle,
    isSweepstakes: formCategory === enums_1.TicketingFormCategory.Sweepstakes,
    formTitle,
    eventStartDate: isShop ? null : eventStartDate,
    eventEndDate: isShop ? null : eventEndDate,
    amount,
    buyerName,
    buyerEmail,
    address,
    fundName,
    paymentMethod,
    isPadOrAch,
    isFreeOrder,
    currency,
    additionalBuyerQuestions,
    participants: isShop ? [] : participants,
    addOns: isShop ? [] : addOns,
    purchasedProducts: isShop ? purchasedProducts : [],
    extraDonation,
    showSavedAmount,
    formattedSavedAmount,
    transactionNumber,
    viewPaymentLink,
    appStoreUrl: (0, mobile_app_links_1.getAppStoreUrl)(),
    playStoreUrl: (0, mobile_app_links_1.getPlayStoreUrl)(),
});
exports.buildOrderReceivedOrganizationMockData = buildOrderReceivedOrganizationMockData;
